export default "__VITE_ASSET__Dr_KwAt8__"